import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import AuthModal from './AuthModal';
import { User, LogOut } from 'lucide-react';

export default function UserAvatar() {
  const { user, logout } = useAuth();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [showMenu, setShowMenu] = useState(false);

  if (showAuthModal) {
    return <AuthModal onClose={() => setShowAuthModal(false)} />;
  }

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      {user ? (
        // Logged in - show user avatar
        <div
          onClick={() => setShowMenu(!showMenu)}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '8px 12px',
            background: '#FF6600',
            color: 'white',
            borderRadius: '50px',
            cursor: 'pointer',
            fontWeight: 'bold',
            fontSize: '12px',
            transition: 'all 0.3s',
            border: '2px solid #FF6600',
          }}
        >
          <div
            style={{
              width: '28px',
              height: '28px',
              borderRadius: '50%',
              background: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#FF6600',
              fontWeight: 'bold',
              fontSize: '14px',
            }}
          >
            {user.name?.[0]?.toUpperCase() || 'U'}
          </div>
          <span>
            {user.name?.split(' ')[0] || 'Lietotājs'}
          </span>
        </div>
      ) : (
        // Not logged in - show login button
        <button
          onClick={() => setShowAuthModal(true)}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            padding: '8px 12px',
            background: 'white',
            color: '#FF6600',
            border: '2px solid #FF6600',
            borderRadius: '50px',
            cursor: 'pointer',
            fontWeight: 'bold',
            fontSize: '12px',
            transition: 'all 0.3s',
          }}
          onMouseEnter={(e) => {
            e.target.style.background = '#FF6600';
            e.target.style.color = 'white';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = 'white';
            e.target.style.color = '#FF6600';
          }}
        >
          <User size={16} />
          Piesakties
        </button>
      )}

      {/* Dropdown menu */}
      {user && showMenu && (
        <div
          style={{
            position: 'absolute',
            top: '100%',
            right: 0,
            marginTop: '8px',
            background: 'white',
            border: '2px solid #FF6600',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            zIndex: 1000,
            minWidth: '180px',
          }}
        >
          <div
            style={{
              padding: '12px',
              borderBottom: '1px solid #eee',
              fontSize: '12px',
              color: '#666',
            }}
          >
            <div style={{ fontWeight: 'bold', color: '#000' }}>
              {user.name}
            </div>
            <div>{user.email}</div>
          </div>
          <button
            onClick={() => {
              logout();
              setShowMenu(false);
            }}
            style={{
              width: '100%',
              padding: '10px 12px',
              background: 'none',
              border: 'none',
              textAlign: 'left',
              fontSize: '13px',
              color: '#dc3545',
              fontWeight: 'bold',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              transition: 'background 0.2s',
            }}
            onMouseEnter={(e) => (e.target.style.background = '#f0f0f0')}
            onMouseLeave={(e) => (e.target.style.background = 'none')}
          >
            <LogOut size={14} />
            Izlogoties
          </button>
        </div>
      )}
    </div>
  );
}
